// Site-preference lead times (business days) with per-market fallbacks, shared
// by every collect adapter.
export const useCollectLeadTimes = () => {
  const preferencesStore = usePreferencesStore()
  const siteId = (localeConfig[useNuxtApp().$i18n.locale.value]?.siteId as SiteIdKey) ?? 'MichaelHillAU'

  return (): CollectLeadTimes => ({
    standardDispatchTime: preferencesStore.site?.standardDispatchTime ?? STANDARD_DISPATCH_TIME[siteId],
    resizeEngravingDelayTime: preferencesStore.site?.resizeEngravingDelayTime ?? RESIZE_DELAY[siteId],
    transitAndStoreProcessingTime:
      preferencesStore.site?.transitAndStoreProcessingTime ?? TRANSIT_AND_STORE_PROCESSING_TIME[siteId],
  })
}
